module.exports = __webpack_public_path__ + "static/media/homePagePhone.9fc33941.mp4";